import PageMigration from '@/pages/PageMigration'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageMigration
	}

	let page = vuewidget(dom, options)
	return page
}